import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  p: 3,
};

const CarOwnerDetailsModal = ({ data, open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="car-owner-details">
      <Box sx={modalStyle}>
        <Typography variant="h6" id="car-owner-details" gutterBottom>
          Car Owner Details
        </Typography>

        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="body" className="fs13" fontWeight="bold" color="text.secondary">
              Name:
            </Typography>
            <Typography variant="body" className="fs13">{data?.car?.userId?.name || "N/A"}</Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="body" className="fs13" fontWeight="bold" color="text.secondary">
              Phone Number:
            </Typography>
            <Typography variant="body" className="fs13">{data?.car?.userId?.phoneNumber || "N/A"}</Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="body" className="fs13" fontWeight="bold" color="text.secondary">
              Email:
            </Typography>
            <Typography variant="body" className="fs13">{data?.car?.userId?.emailId || "N/A"}</Typography>
          </Box>
          {/* <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="body" className="fs13" fontWeight="bold" color="text.secondary">
              Address:
            </Typography>
            <Typography variant="body" className="fs13">{data?.user?.address || "N/A"}</Typography>
          </Box> */}
        </Box>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button variant="contained" className="btn-theme" onClick={handleClose} >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CarOwnerDetailsModal;
